






















import Vue from 'vue';
export default Vue.extend({
  name: 'PageBanner',
  props: {
    imagePath: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      required: true,
    },
    showSubheading: {
      type: Boolean,
      default: false,
    },
    subheadingText: {
      type: String,
      default: '',
    },
    subheadingRoute: {
      type: [Object, String],
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
});
